import axios from "axios";

const listInscriptions = {
    namespaced: true,
    state: {
        searchFilter: "",
        searchedInscriptions: [],
    },
    mutations: {
        setSearchedInscriptions(state, inscriptions) {
            state.searchedInscriptions = inscriptions;
        },
        setSearchFilter(state, searchFilter) {
            state.searchFilter = searchFilter;
        },
    },
    getters: {
        searchedInscriptions(state) {
            return state.searchedInscriptions;
        },
    },
    actions: {
        async searchInscriptions({ commit, state, rootState, dispatch }, routeParams = {}) {
            if (state.searchFilter.length < 1) {
                commit("setSearchedInscriptions", []);
                return;
            }
            const response = await axios.get(rootState.base_url + "/nm/inscription/get.php?base=" + rootState.module.base + "&search=" + state.searchFilter);
            if (response.data.list) {
                commit("setSearchedInscriptions", response.data.list);
            } else {
                commit("setSearchedInscriptions", []);
            }
        },
    },
};

export default listInscriptions;